import React from "react";
import CustomTextbox from "../../components/Forms/CustomInputs/CustomTextbox";

const AddUpdateUI = ({ formik }) => {
  const { values, errors, handleChange, handleBlur } = formik;
  return (
    <>
      <CustomTextbox
        fieldName="name"
        value={values.name}
        error={errors.name}
        label={"Country Name"}
        classes={"col-md-12"}
        handleBlur={handleBlur}
        inputType={"text"}
        handleChange={handleChange}
      />
      <CustomTextbox
        fieldName="phonecode"
        value={values.phonecode}
        error={errors.phonecode}
        label={"Phone Code"}
        classes={""}
        handleBlur={handleBlur}
        inputType={"text"}
        handleChange={handleChange}
      />

      <CustomTextbox
        fieldName="code"
        value={values.code}
        error={errors.code}
        label={"Country Code"}
        classes={""}
        handleBlur={handleBlur}
        inputType={"text"}
        handleChange={handleChange}
      />
    </>
  );
};

export default AddUpdateUI;
